// extracted by mini-css-extract-plugin
export var borderRadius = "_g3-4";
export var large = "_g3-3";
export var logoContainer = "_g3-0";
export var nameLogo = "_g3-2";
export var small = "_g3-1";